import React from "react";
import "./assets/scss/themes.scss";
import Route from "./Routes";
import { ToastContainer } from "react-toastify";
import { PermissionsProvider } from "pages/Authentication/PermissiosnProvider";
function App() {
  return (
    <PermissionsProvider>
      <React.Fragment>
        <ToastContainer />
        <Route />
      </React.Fragment>
    </PermissionsProvider>
  );
}

export default App;
